import { render, staticRenderFns } from "./FormOportunidades.vue?vue&type=template&id=2a4e224f"
import script from "./FormOportunidades.vue?vue&type=script&lang=js"
export * from "./FormOportunidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports